import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from '../../select';
import { UPDATE_NAV_ITEM } from 'store/modules/competition-nav/actions';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { getTranslation } from '../../../utils/translations';

export const LocationNavItem = ({ locations }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    const initialLocation = useMemo(() => {
        return locations?.find(
            (l) =>
                l.value ===
                PULSE.app.common.modifyCountryDisplay(nav.location.location)
        );
    }, [nav.location, locations]);

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={locations}
                itemToString={(location) => location?.value}
                initialSelectedItem={initialLocation?.value}
                activeItem={initialLocation}
                label={getTranslation('label.filters.location')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        UPDATE_NAV_ITEM.request({
                            navItem: 'location',
                            value: {
                                timezone: selectedItem.extra.timezone,
                                id: selectedItem.extra.id,
                                regionName: selectedItem.extra.name,
                                location:
                                    selectedItem.extra.timezone.split('/')[0],
                                region: selectedItem.extra.timezone.split(
                                    '/'
                                )[1]
                            }
                        })
                    );
                }}
            />
        </div>
    );
};

LocationNavItem.propTypes = {
    locations: PropTypes.array
};
